import { z } from 'zod'

export const notificationsQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(50).default(20),
})

export type NotificationsQueryDto = z.infer<typeof notificationsQuerySchema>
